<mat-dialog-content class="mat-typography">
  <spt-privacy-policy></spt-privacy-policy>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>
